import React from "react";
import { useLocation } from "react-router-dom";

/** Kick off Google sign-in through Emergent auth; where to go afterwards is kept in sessionStorage. */
export function startGoogleSignIn(next: string, ref = "") {
  sessionStorage.setItem("google_after", JSON.stringify({ next: next || "/", ref }));
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirectUrl = window.location.origin + "/auth/google";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

export function GoogleMark({ className = "h-4 w-4" }: { className?: string }) {
  return (
    <svg viewBox="0 0 48 48" className={className} aria-hidden="true">
      <path fill="#EA4335" d="M24 9.5c3.5 0 6.7 1.2 9.2 3.6l6.9-6.9C35.9 2.4 30.3 0 24 0 14.6 0 6.5 5.4 2.6 13.3l8 6.2C12.5 13.6 17.8 9.5 24 9.5z" />
      <path fill="#4285F4" d="M46.5 24.5c0-1.6-.1-3.1-.4-4.5H24v9h12.7c-.6 3-2.3 5.5-4.8 7.2l7.5 5.8c4.4-4.1 7.1-10.1 7.1-17.5z" />
      <path fill="#FBBC05" d="M10.6 28.5A14.5 14.5 0 0 1 9.5 24c0-1.6.3-3.1.8-4.5l-8-6.2A24 24 0 0 0 0 24c0 3.9.9 7.5 2.6 10.7l8-6.2z" />
      <path fill="#34A853" d="M24 48c6.3 0 11.7-2.1 15.6-5.7l-7.5-5.8c-2.1 1.4-4.8 2.3-8.1 2.3-6.2 0-11.5-4.1-13.4-9.8l-8 6.2C6.5 42.6 14.6 48 24 48z" />
    </svg>
  );
}

export function GoogleButton({ next, ref: refCode = "", label = "Continue with Google", className = "", testId = "google-signin-button" }: { next?: string; ref?: string; label?: string; className?: string; testId?: string }) {
  const { pathname, search } = useLocation();
  return (
    <button type="button" onClick={() => startGoogleSignIn(next ?? pathname + search, refCode)}
      className={`inline-flex w-full items-center justify-center gap-3 border border-border bg-white px-4 py-3 text-sm transition-colors duration-200 hover:border-[var(--ink)] ${className}`} data-testid={testId}>
      <GoogleMark /> <span>{label}</span>
    </button>
  );
}

export function OrRule({ text = "or" }: { text?: string }) {
  return <div className="my-4 flex items-center gap-3 text-[10px] uppercase tracking-[0.2em] text-neutral-400"><span className="h-px flex-1 bg-border" />{text}<span className="h-px flex-1 bg-border" /></div>;
}
